import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../elements/Navbar';
import Form from '../components/Form';
import InputField from '../components/InputField';
import ResponseBlock from '../components/ResponseBlock';
import { BeatLoader } from 'react-spinners';

function FlavorProfileUpdater() {
  const [userEmail, setUserEmail] = useState('');
  const [file, setFile] = useState(null);
  const [isFileEmpty, setIsFileEmpty] = useState(false);
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
      const email = localStorage.getItem("userEmail"); // ✅ Retrieve email from localStorage
      if (email) {
        setUserEmail(email);
      }
    }, []);
  
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setMessage('');
    setErrors(false);
  };

  const handleCancel = (event) => {
    event.preventDefault();
    setFile(null);
    setIsFileEmpty(false);
    setMessage('');
  };

  const handleSubmit = async (event) => {
    setIsFileEmpty(false);
    
    if (!file) {
      setIsFileEmpty(true);
      setErrors(true);
      setMessage('Please select a file before submitting.');
      return;
    };

    setIsLoading(true);
    setMessage('');
    
    const formData = new FormData();
    formData.append('file', file);

    formData.append('email', userEmail);

    try {
      const baseUrl = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_URL_BASE_DEV : process.env.REACT_APP_API_URL_BASE_PROD;
      const response = await axios.post(`${baseUrl}/csv_processor/flavor-profile-updater`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      const data = response.data;

      if (data.error) {
        setIsLoading(false);
        setErrors(true);
        setMessage(data.error);
      } else {
        setIsLoading(false);
        setMessage(data.message);
      }

    } catch (error) {
      console.error("There was an error uploading the file!", error);
      setMessage('An error occurred while uploading the file.');
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1450)
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container mx-auto">
        <div className="updaterWrapper">
          <div className="space-y-12">
            <h1 className="text-2xl font-semibold leading-7 text-gray-900">Flavor Profile Updater App</h1>
            <p>
              The Flavor Profile Updater App allows you to update the flavor profiles for products in bulk. You must use a CSV file with the following headers: <strong><em>ID</em>, <em>Title</em>, and <em>Flavor Profile</em></strong>. The ID is the Shopify Product ID, the Title is the name of the product, and the Flavor Profile is the new flavor profile you want to set for the product.
            </p>
            <p>Please see the example below for how to format your CSV file. <strong>Important: Please note how the Flavor Profile is formatted.</strong></p>
            <div>
              <table className="min-w-full border border-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="border border-gray-300 px-6 py-4 text-left text-sm font-semibold text-gray-900">ID</th>
                    <th className="border border-gray-300 px-6 py-4 text-left text-sm font-semibold text-gray-900">Title</th>
                    <th className="border border-gray-300 px-6 py-4 text-left text-sm font-semibold text-gray-900">Flavor Profile</th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  <tr>
                    <td className="border border-gray-300 px-6 py-4 text-sm text-gray-900">1234567890</td>
                    <td className="border border-gray-300 px-6 py-4 text-sm text-gray-900">Delicious Strawberry Candy</td>
                    <td className="border border-gray-300 px-6 py-4 text-sm text-gray-900">["Fruity"]</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="formWrapper mt-11">
            <Form onSubmit={handleSubmit}>
              <div className="grid grid-cols-6 border-b border-gray-900/10 pb-12 space-y-2">
                <div className="col-start-3 col-span-2 relative">
                  <InputField 
                    label="Choose a file" 
                    type="file" 
                    name="csv_file" 
                    onChange={handleFileChange}
                    error={isFileEmpty}
                    classes="w-full text-sm text-slate-500 p-3 outline-0
                            file:mr-4 file:py-2 file:px-4
                            file:rounded-full file:border-0
                            file:text-sm file:font-semibold
                            file:bg-violet-50 file:text-violet-700
                            hover:file:bg-violet-100 mb-4"
                  />
                </div>
                <div className="col-end-5 col-span-1 text-right space-x-3">
                  <button className="text-rose-700 font-semibold py-2 px-4 rounded" onClick={handleCancel}>
                    Cancel
                  </button>
                  <button className="w-1/2 bg-indigo-500 text-white font-bold py-2 px-4 rounded-lg" 
                          type="submit"
                          disabled={isLoading}>
                    { isLoading ? <BeatLoader /> : 'Submit' }
                  </button>
                </div>
              </div>
            </Form>
          </div>
          <div className="responseWrapper">
            <ResponseBlock 
              message={message}
              errors={errors}
              fileType='csv'
            />
          </div>
          </div>
        </div>
    </div>
  )
}

export default FlavorProfileUpdater;